import { render, staticRenderFns } from "./CandidateExamAndResult.vue?vue&type=template&id=274f2233&"
import script from "./CandidateExamAndResult.vue?vue&type=script&lang=js&"
export * from "./CandidateExamAndResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports